import { Carousel as CarouselOriginal, Slide } from 'vue-carousel/src'

const Carousel = {
  name: 'Carousel',
  extends: CarouselOriginal,
  data() {
    return {
      computedSlideWidth: 0,
    }
  },
  computed: {
    slideWidth() {
      const width = this.carouselWidth - this.spacePadding * 2
      const perPage = this.currentPerPage

      const perPageWidth = width / perPage

      // THIS IS AN OVERRIDE TO ACTUAL IMPLEMENTATION
      // When Slider has components of fixed width larger than estimated width,
      // use the computed width of slide
      if (perPageWidth < this.computedSlideWidth) {
        return this.computedSlideWidth
      }

      return perPageWidth
    },
  },
  methods: {
    goToPage(page, advanceType) {
      // TODO: https://app.asana.com/0/1199913855170360/1200041494905009/f
      // Get back to original vue - carousel after bug fix got merged.
      // Original code: if (page >= 0 && page <= this.pageCount) {
      if (page >= 0 && page <= this.slideCount) {
        this.offset = this.scrollPerPage
          ? Math.min(this.slideWidth * this.currentPerPage * page, this.maxOffset)
          : this.slideWidth * page

        // restart autoplay if specified
        if (this.autoplay && !this.autoplayHoverPause) {
          this.restartAutoplay()
        }

        // update the current page
        this.currentPage = page

        if (advanceType === 'pagination') {
          this.pauseAutoplay()
          this.$emit('pagination-click', page)
        }
      }
    },

    computeSlideWidth() {
      this.computedSlideWidth = this.$el?.querySelector('.VueCarousel-slide').clientWidth
    },
  },

  mounted() {
    this.computeSlideWidth()
  },
}
export { Carousel, Slide }
